import React, { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Popover, PopoverContent, PopoverTrigger, PopoverClose } from '@/components/ui/popover';
import { Icon } from '@/components/shared/display/Icon';
import { CloseIcon } from '@/assets/Icons';

const closeButtonSizeOptions = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
};

interface BasePopoverProps {
  children: ReactNode;
  content: ReactNode | string;
  onOpenChange?: (open: boolean) => void;
  closeButtonSize?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const BasePopover = ({
  children,
  content,
  onOpenChange,
  closeButtonSize,
  className,
  ...rest
}: BasePopoverProps) => {
  return (
    <Popover onOpenChange={onOpenChange}>
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent className={className} {...rest}>
        {content}
        {closeButtonSize && (
          <PopoverClose
            className={cn('absolute top-3 right-3 hover:opacity-70', closeButtonSizeOptions[closeButtonSize])}
          >
            <Icon icon={CloseIcon} />
          </PopoverClose>
        )}
      </PopoverContent>
    </Popover>
  );
};
